import initialState from './notifications.initialState';
import { FETCH_NOTIFICATIONS_PANEL_DATA } from './types';

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_PANEL_DATA: {
      return action.notifications;
    }
    default:
      return state;
  }
}
